import React from 'react'
import { Global, css } from '@emotion/react'

import styles from './styles'

/**
 * Add styles for visually tracking @ds/ui component usages on product surfaces.
 * These styles will only be applied conditionally
 * (if the `dsUiTracker` local storage value is set to `true`).
 */
export function DsUiTrackerCss() {
  return <Global styles={css(styles)} />
}
